/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Directory_Platforms_Listing_DescriptionInputs */

const en_directory_platforms_listing_description = /** @type {(inputs: Directory_Platforms_Listing_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore published products that list ${i?.platform} among their supported platforms.`)
};

const zh_directory_platforms_listing_description = /** @type {(inputs: Directory_Platforms_Listing_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`浏览将 ${i?.platform} 列为支持平台的已发布产品。`)
};

/**
* | output |
* | --- |
* | "Explore published products that list {platform} among their supported platforms." |
*
* @param {Directory_Platforms_Listing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_listing_description = /** @type {((inputs: Directory_Platforms_Listing_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_Listing_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_listing_description(inputs)
	return zh_directory_platforms_listing_description(inputs)
});
export { directory_platforms_listing_description as "directory.platforms.listing_description" }